/**
 * shared/constants.js
 *
 * Constantes partilhadas entre user-frontend e admin-frontend.
 * Centraliza locale, moeda e configurações da plataforma.
 */

// ─── Localização ─────────────────────────────────────────────
// FIX: era pt-BR (Brasil) ou en-US em toda a base de código
export const LOCALE = 'pt-PT';
export const CURRENCY = 'AOA'; // Kwanza angolano
export const CURRENCY_SYMBOL = 'Kz';
export const TIMEZONE = 'Africa/Luanda';

// ─── Formatadores reutilizáveis ───────────────────────────────
export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString(LOCALE, {
    year: 'numeric', month: 'long', day: 'numeric',
  });
};

export const formatDateShort = (dateString) => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString(LOCALE);
};

export const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleString(LOCALE);
};

export const formatTimeAgo = (timestamp) => {
  const diff = Math.floor((Date.now() - new Date(timestamp)) / 1000);
  if (diff < 60) return 'Agora';
  if (diff < 3600) return `há ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `há ${Math.floor(diff / 3600)} h`;
  if (diff < 604800) return `há ${Math.floor(diff / 86400)} d`;
  return formatDateShort(timestamp);
};

export const formatCurrency = (amount) => {
  if (amount == null) return 'N/A';
  return `${CURRENCY_SYMBOL} ${Number(amount).toLocaleString(LOCALE)}`;
};

// ─── Status labels ────────────────────────────────────────────
export const REQUEST_STATUS_LABELS = {
  pending:     'Pendente',
  accepted:    'Aceite',
  in_progress: 'Em execução',
  completed:   'Concluído',
  cancelled:   'Cancelado',
  open:        'Aberta',
  closed:      'Fechada',
  approved:    'Aprovada',
};

export const DISPUTE_STATUS_LABELS = {
  open:         'Aberta',
  under_review: 'Em Análise',
  resolved:     'Resolvida',
  escalated:    'Escalada',
  closed:       'Fechada',
};

export const WORKER_STATUS_LABELS = {
  available: 'Disponível',
  busy:      'Ocupado',
  offline:   'Indisponível',
  pending:   'Pendente',
  verified:  'Verificado',
};

export const ROLE_LABELS = {
  client: 'Cliente',
  worker: 'Profissional',
  admin:  'Administrador',
};

// ─── Configuração Socket ──────────────────────────────────────
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3000';

/**
 * Apoio mostrado ao profissional enquanto a conta não está activa.
 * O repositório não tem telefone nem WhatsApp da Dozy — o domínio público
 * é dozyy.net e não há caixa de correio confirmada. Sem número, o ecrã
 * mostra só o texto. Quando existir, preencher uma das variáveis:
 * REACT_APP_DOZY_SUPORTE_WHATSAPP (preferido) ou REACT_APP_DOZY_SUPORTE_TEL.
 */
export const CONTACTO_DOZY = {
  rotulo: 'Falar com a Dozy',
  telefone: process.env.REACT_APP_DOZY_SUPORTE_TEL || '',
  whatsapp: process.env.REACT_APP_DOZY_SUPORTE_WHATSAPP || '',
};

export function hrefContactoDozy() {
  const wa = String(CONTACTO_DOZY.whatsapp || '').replace(/\D/g, '');
  if (wa) return `https://wa.me/${wa}`;
  const tel = String(CONTACTO_DOZY.telefone || '').replace(/\s/g, '');
  if (tel) return `tel:${tel}`;
  return null;
}
